// src/components/elements/AuthButton.js
import React from 'react';
import useUserStore from '../../contexts/useUserStore';

const AuthButton = () => {
  const { isAuthenticated, login, logout, isSigningIn } = useUserStore();

  return isAuthenticated ? (
    <button
      onClick={logout}
      className="font-bold text-[var(--brandsecondary)] text-sm flex items-center justify-end"
    >
      Log Out
      <i className="bi bi-box-arrow-right ml-2"></i>
    </button>
  ) : (
    <button
      onClick={login}
      className="font-bold text-[var(--brandsecondary)] text-sm flex items-center justify-end"
      disabled={isSigningIn} // Disable when signing in
    >
      Log In
      <i className="bi bi-box-arrow-in-right ml-2"></i>
    </button>
  );
};

export default AuthButton;
